module.exports = __webpack_public_path__ + "media/components/assets/dabang_photo-95af1deb115c49091d7abd90cb10cd0c.png";